module.exports = __webpack_public_path__ + "images/home-v2-bg-hero.webp";